// removed by extract-text-webpack-plugin
module.exports = {"container":"_2QYm5AAMG7j7C_Cwknv2rl","checkbox":"_1MRbMyIUjXROJTYMxYNORB","checked":"_1EiENKL2Vjw4xD_Zi87Y_9","radio":"_3T5mBaVtdsX2ulLr3oV4nL","label2":"_1-F2NvN0NSFUZ1dh1zAF5L"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Checkbox/Checkbox.css
// module id = 1063
// module chunks = 58